module.exports = __webpack_public_path__ + "static/praxisHome-6281d4930eacb71c0af5cc0aafc88494.jpg";